<template>
    <div class="e-type-select" v-bind:class="{ 'active': showList }">
        <input :type="input.inputType || 'text'" class="e-type-select--input" :placeholder="input.placeholder"
            :class="input.class" :disabled="input.disabled" v-on:input="handleInput()"
            v-on:click="filteredOptions = options; showList = true" v-model="inputValue">
        <span class="select-tick">❮</span>
        <ul class="e-type-select--list" :class="list.class"
            v-if="showList || (inputValue && !inputValue.includes(input.sufix))">
            <li class="e-type-select--item" v-if="inputValue"
                v-on:click="selectValue($event, { val: inputValue.replace(input.sufix, '') })">
                {{ inputValue.replace(input.sufix, '') }} {{ input.sufix }}</li>
            <li v-for="(option, key) in filteredOptions" :key="key" class="e-type-select--item"
                v-on:click="selectValue($event, option);">
                <slot :option="option"></slot>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'typeSelect',
    data() {
        return {
            inputValue: '',
            selectedValue: false,
            showList: false,
            filteredOptions: {}
        }
    },
    props: {
        options: {
            default: () => {
                return {
                }
            }
        },
        filterFunction: {
            type: Function,
            default: (value, search) => value.toLowerCase().includes(search.toLowerCase())
        },
        limit: {
            type: Number,
            default: 1000
        },
        input: {
            type: Object,
            default: () => {
                return {
                    inputType: 'text',
                    class: 'e-type-select--input__primary',
                    disabled: false,
                    sufix: 'PLN',
                    placeholder: 'Podaj'
                }
            }
        },
        list: {
            type: Object,
            default: () => {
                return {
                    class: 'e-type-select-list__list__primary'
                }
            }
        }
    },
    methods: {
        handleInput() {
            this.$emit('typing', this.inputValue);
            if (this.inputValue.length != 0) {
                this.filteredOptions = this.options.filter((k) => this.filterFunction(k, this.inputValue));
            } else {
                this.filteredOptions = this.options;
            }
            this.showList = Object.keys(this.filteredOptions).length === 0 ? false : true;
        },
        selectValue(event, value) {
            this.selectedValue = value;
            this.inputValue = event.srcElement.innerText;
            this.$emit('selectValue', value);
            setTimeout(() => {
                this.showList = false
            }, 100)
        }
    },
    watch: {
        showList: {
            handler(status) {
                // This closes options when you click outside input
                var that = this;
                if (status) {
                    setTimeout(function () {
                        var elem = document.querySelector('.e-type-select.active');
                        document.addEventListener('click', function (event) {
                            if (elem != null) {
                                var isClickInside = elem.contains(event.target);
                                if (!isClickInside) {
                                    that.showList = false;
                                }
                            }
                        });
                    }, 100);
                } else {
                    document.removeEventListener("click", (e) => {
                        e.preventDefault();
                    }, false);
                }

            }
        }
    }
}
</script>
<style lang="scss">
.e-type-select {
    position: relative;
}

.select-tick {
    position: absolute;
    right: 1rem;
    top: 1.5rem;
    transform: rotate(-90deg);
    line-height: 1;
}

.e-type-select--item {
    cursor: pointer;
    padding: 0 1rem;
}

.e-type-select--item:hover {
    background: #c4cdcf;
}

.e-type-select--input::placeholder {
    color: $gray;
}

.e-type-select.active {
    z-index: 9999;

    .select-tick {
        transform: rotate(0deg);
    }
}

.e-type-select .select-tick {
    margin-top: .25rem;
}

.e-type-select--list {
    z-index: 777;
    box-shadow: -5px -5px 35px -24px rgba(0, 0, 0, 0.75);
    list-style-type: none;
    border: 1px solid $brightgray;
    background-color: $white;
    color: $gray;
    border-radius: .25rem;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1rem;
    margin-top: 100%;
    max-height: 30vh;
    overflow-y: auto;
    z-index: 999999;
    transform: translateY(100%) translateZ(100px);
    min-width: 145px;
    padding-left: 0;

    li {
        padding: .25rem 1.25rem;

        &:hover {
            // background-color: $red;
            color: $white;
        }

        &.active {
            &::after {
                content: '✓';
                width: 1rem;
                height: 1rem;
                background-color: $gray;
                display: block;
                position: absolute;
                right: .5rem;
                top: .35rem;
                border-radius: .25rem;
                text-align: center;
                color: $white;
                line-height: 1.2;
                font-size: .8rem;
            }
        }
    }


}
</style>